export type Coords = { x: number; y: number };

export function isPointInTriangle(mouse: Coords, left: Coords, topRight: Coords, bottomRight: Coords) {
  const { x: px, y: py } = mouse;
  const { x: ax, y: ay } = left;
  const { x: bx, y: by } = topRight;
  const { x: cx, y: cy } = bottomRight;

  const v0x = cx - ax;
  const v0y = cy - ay;
  const v1x = bx - ax;
  const v1y = by - ay;
  const v2x = px - ax;
  const v2y = py - ay;

  const dot00 = v0x * v0x + v0y * v0y;
  const dot01 = v0x * v1x + v0y * v1y;
  const dot02 = v0x * v2x + v0y * v2y;
  const dot11 = v1x * v1x + v1y * v1y;
  const dot12 = v1x * v2x + v1y * v2y;

  const invDenom = 1 / (dot00 * dot11 - dot01 * dot01);
  const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
  const v = (dot00 * dot12 - dot01 * dot02) * invDenom;

  return u >= 0 && v >= 0 && u + v < 1;
}

export function isCoordsInTriangle(pos: Coords, leftRect: DOMRect, rightRect: DOMRect) {
  const leftX = leftRect.left + leftRect.width / 2;
  const leftY = leftRect.top + leftRect.height / 2;

  const topRightX = rightRect.left;
  const topRightY = rightRect.top;

  const bottomRightX = rightRect.left;
  const bottomRightY = rightRect.bottom;

  return isPointInTriangle(
    pos,
    { x: leftX, y: leftY },
    { x: topRightX, y: topRightY },
    { x: bottomRightX, y: bottomRightY }
  );
}
